import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { AssetClassOverviewFacade } from '@zero/asset-class-overview/domain';
import { MostFamousAssetsComponent } from '@zero/asset-class-overview/feature-shared/web';
import { InstrumentType } from '@zero/shared/util-models';

@Component({
  selector: 'stocks-famous',
  imports: [MostFamousAssetsComponent, AsyncPipe],
  templateUrl: './famous-stocks.component.html',
})
export class FamousStocksComponent implements OnInit {
  public readonly facade = inject(AssetClassOverviewFacade);
  public readonly type = InstrumentType.Share;

  ngOnInit(): void {
    this.facade.loadMostPopularStocks();
  }
}
